module.exports = __webpack_public_path__ + "img/ico-pressure-low-p.fd181dc1.png";